import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import NavierasCreate from "./NavierasCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Baja from "../../Baja";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import ExportJsonExcel from "js-export-excel";

function ListadoNavieras() {
  const { user } = useContext(AuthContext);
  const URL_NAVIERAS = process.env.REACT_APP_URL_NAVIERAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [navieras, setNavieras] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);
  const [t, i18n] = useTranslation("global");

  const [idEdit, setIdEdit] = useState()
  const [clientes, setClientes] = useState([]);
  const [excepciones, setExcepciones] = useState(null); // { naviera, lista: [{clientes, dias}] }

  useEffect(() => {
    axios
      .get(URL_NAVIERAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allNavieras = response.data;
        setNavieras(allNavieras);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(process.env.REACT_APP_URL_CLIENTES, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((response) => setClientes(response.data.filter((c) => c.is_active !== "No")))
      .catch((err) => console.log(err));
  }, []);

  function patchNaviera(naviera, cambios, mensaje) {
    return axios
      .patch(
        `${process.env.REACT_APP_URL_NAVIERAS}/${naviera._id}`,
        cambios,
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        setNavieras((ns) => ns.map((n) => (n._id === naviera._id ? { ...n, ...cambios } : n)));
        Swal.fire({ toast: true, position: "top-end", icon: "success", title: mensaje, showConfirmButton: false, timer: 1600 });
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "No se pudo guardar", text: error?.response?.data?.message || error.message });
        throw error;
      });
  }

  // Excepción por cliente (ej. contrato Maersk): esos días ganan sobre los de la naviera
  function guardaExcepciones() {
    const lista = excepciones.lista
      .filter((x) => x.clientes && x.dias !== "" && x.dias !== null)
      .map((x) => ({ clientes: x.clientes, dias: Number(x.dias) }));
    patchNaviera(excepciones.naviera, { excepcionesDiasLibres: lista }, `${excepciones.naviera.name}: ${lista.length} excepción(es)`)
      .then(() => setExcepciones(null))
      .catch(() => {});
  }
  const nombreCliente = (id) => (clientes.find((c) => c._id === id) || {}).nombre_comercial || "Cliente";

  function excel() {
    const dataExcel = navieras.map((a) => { {
        return {
          name: a.name
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoNavieras";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoNavieras",
        sheetFilter: [
          "name"
        ],
        sheetHeader: [
          "name"
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function editNaviera(event) {
    event.preventDefault();
    const URL_NAVIERAS_EDIT = `${process.env.REACT_APP_URL_NAVIERAS}/${idEdit}`;
    axios
      .patch(
        URL_NAVIERAS_EDIT,
        {
          name
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Naviera',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  // Días libres de demoras: se guardan al salir del campo y Revalidaciones los jala solos
  function guardaDiasLibres(naviera, valor) {
    const nuevo = valor === "" ? null : Number(valor);
    if ((naviera.diasLibresDemoras ?? null) === nuevo) return;
    axios
      .patch(
        `${process.env.REACT_APP_URL_NAVIERAS}/${naviera._id}`,
        { diasLibresDemoras: nuevo },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        setNavieras((ns) => ns.map((n) => (n._id === naviera._id ? { ...n, diasLibresDemoras: nuevo } : n)));
        Swal.fire({ toast: true, position: "top-end", icon: "success", title: `${naviera.name}: ${nuevo ?? "sin"} días libres`, showConfirmButton: false, timer: 1600 });
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "No se pudo guardar", text: error?.response?.data?.message || error.message });
      });
  }

  function jalaInfo(idEdit, name) {
        setName(name);
        setIdEdit(idEdit);
        toggle();
  }

  return (
    <>
      <Header />
      <div className="container col-sm-11">
        { user.menuNavieras ? (
          <>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <span className="page-title-icon"><i className="fas fa-ship" /></span>
                {t("Navieras")}
              </h3>
              <p className="page-subtitle">{t("Catálogo de navieras")}</p>
            </div>
          </div>
          <div className="stats-row">
            <div className="stat-chip"><i className="fas fa-list" style={{ color: "#2563eb" }} /> {t("Registros")} <span>{navieras.length}</span></div>
          </div>
          <div className="row">
            {
              <div className="col-md-8 col-sm-12">
                <div className="card">
                  <div className="card-body">
                    {/* <Button
                                      size="sm"
                                      className="btn"
                                      color="primary"
                                      onClick={excel}
                                    >
                                      Excel <i class="far fa-file-excel"></i>
                                    </Button> */}
                    <Table
                      size="sm"
                      hover
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">{t("Nombre")}</th>
                          <th className="tituloTabla td-num" title={t("Se usan en Revalidaciones para calcular el deadline de demoras")}>{t("Días libres demoras")}</th>
                          <th className="tituloTabla" title={t("Desde cuándo corren los días libres")}>{t("Corren desde")}</th>
                          <th className="tituloTabla">{t("Excepciones por cliente")}</th>
                          <th className="tituloTabla">{t("Editar")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {navieras
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td className="td-strong">{a.name}</td>
                                  <td style={{ width: 120 }}>
                                    <Input
                                      bsSize="sm"
                                      type="number"
                                      min="0"
                                      placeholder="—"
                                      defaultValue={a.diasLibresDemoras ?? ""}
                                      onBlur={(e) => guardaDiasLibres(a, e.target.value)}
                                      onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
                                      style={{ textAlign: "right" }}
                                    />
                                  </td>
                                  <td style={{ width: 150 }}>
                                    <Input
                                      bsSize="sm"
                                      type="select"
                                      value={a.inicioDiasLibres || "Puerto"}
                                      onChange={(e) => {
                                        const v = e.target.value;
                                        patchNaviera(a, { inicioDiasLibres: v }, `${a.name}: días libres desde ${v === "Tren" ? "la carga en tren" : "el arribo a puerto"}`).catch(() => {});
                                      }}
                                    >
                                      <option value="Puerto">{t("Puerto")}</option>
                                      <option value="Tren">{t("Tren")}</option>
                                    </Input>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className={`badge-soft badge-soft-${(a.excepcionesDiasLibres || []).length ? "info" : "secondary"} rv-badge-btn`}
                                      onClick={() => setExcepciones({ naviera: a, lista: (a.excepcionesDiasLibres || []).map((x) => ({ ...x })) })}
                                    >
                                      {(a.excepcionesDiasLibres || []).length
                                        ? (a.excepcionesDiasLibres || []).map((x) => `${nombreCliente(x.clientes)}: ${x.dias}`).join(", ")
                                        : t("Agregar")}
                                    </button>
                                  </td>
                                  <td>
                                    {/* <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(a._id, a.name)}
                                    >
                                      <i class="far fa-edit"></i>{" "}
                                    </Button> */}

                                    <Baja
                                      idStatus={a._id}
                                      is_active={a.is_active}
                                      URL_BAJA={
                                        process.env.REACT_APP_URL_NAVIERAS
                                      }
                                    />
                              
                                   
                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-4 col-sm-12">
              <div className="card">
                <div className="card-body">
                  <NavierasCreate />
                </div>
              </div>
            </div>
          </div>
          </>
        ) : undefined}
      </div>
      <Modal isOpen={!!excepciones} toggle={() => setExcepciones(null)}>
        <ModalHeader toggle={() => setExcepciones(null)}>
          {t("Días libres por cliente")} · {excepciones ? excepciones.naviera.name : ""}
        </ModalHeader>
        <ModalBody>
          <div className="td-muted" style={{ fontSize: "0.75rem", marginBottom: 10 }}>
            {t("Naviera")}: {excepciones ? excepciones.naviera.diasLibresDemoras ?? "—" : ""} {t("días")}. {t("Si el cliente tiene contrato con otros días, agrégalo aquí.")}
          </div>
          {excepciones
            ? excepciones.lista.map((x, i) => (
                <Row key={i} className="mb-2 align-items-center" noGutters>
                  <div style={{ flex: 1, marginRight: 8 }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={x.clientes || ""}
                      onChange={(e) => {
                        const v = e.target.value;
                        setExcepciones((ex) => ({ ...ex, lista: ex.lista.map((y, j) => (j === i ? { ...y, clientes: v } : y)) }));
                      }}
                    >
                      <option value="">{t("Selecciona")}</option>
                      {clientes
                        .slice()
                        .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                        .map((c) => <option key={c._id} value={c._id}>{c.nombre_comercial}</option>)}
                    </Input>
                  </div>
                  <div style={{ width: 90, marginRight: 8 }}>
                    <Input
                      bsSize="sm"
                      type="number"
                      min="0"
                      placeholder={t("Días")}
                      value={x.dias ?? ""}
                      onChange={(e) => {
                        const v = e.target.value;
                        setExcepciones((ex) => ({ ...ex, lista: ex.lista.map((y, j) => (j === i ? { ...y, dias: v } : y)) }));
                      }}
                    />
                  </div>
                  <Button
                    size="sm"
                    color="danger"
                    onClick={() => setExcepciones((ex) => ({ ...ex, lista: ex.lista.filter((_, j) => j !== i) }))}
                  >
                    <i className="fas fa-trash-alt" />
                  </Button>
                </Row>
              ))
            : null}
          <Button size="sm" color="info" onClick={() => setExcepciones((ex) => ({ ...ex, lista: [...ex.lista, { clientes: "", dias: "" }] }))}>
            <i className="fas fa-plus" /> {t("Agregar cliente")}
          </Button>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardaExcepciones}>
            <i className="fas fa-save" /> {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t("Editar")} {t("Naviera")}</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">{t("Nombre")}</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editNaviera}>
            <i className="fas fa-save" /> {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoNavieras;
